// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wq_a bie_b"};